var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFileFolderIcon = function SvgFileFolderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 28",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.833 28c-.834 0-1.792-.666-1.784-1.89l-.05-24.548C-.001.704.703 0 1.563 0h6.436l4 4h20v24H1.833z",
    fill: "currentColor"
  })));
};
export default SvgFileFolderIcon;